<template>
    <label for="card_number" :class="label_style">Número de tarjeta</label>
    <input
        type="text"
        name="card_number"
        id="card_number"
        :class="input_style"
        :required="required"
        minlength="16"
        maxlength="16"
        placeholder="1234 1234 1234 1234"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
    <p :class="message_style" v-show="isValid">Por favor ingrese un número de tarjeta válido.</p>
</template>

<script>
import {lunh} from "../../common/card-utils";

    export default {
        emits: ['update:modelValue', 'update:error'],
        props: {
            modelValue: {
                type: String,
                required: false,
                default: null
            },
            error: {
                type: Boolean,
                default: false
            },
            input_style: {
                type: String,
                default: ''
            },
            label_style: {
                type: String,
                default: ''
            },
            message_style: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                message: null,
                isValid: false,
            }
        },

        watch: {
            modelValue(value){
                this.validateCardNumber(value);
            }
        },

        methods: {
            validateCardNumber(cardNumber){
                this.isValid = !lunh(cardNumber);
                this.$emit('update:error', this.isValid);
            }
        }
    }
</script>
